import { timeProvider } from "../AppController";

export type ISendZapierTrigger = (obj: {
  email: string;
  name: string;
}) => Promise<void>;

export const sendZapierTrigger: ISendZapierTrigger = async (userData) => {
  await fetch("https://hooks.zapier.com/hooks/catch/21246256/2z9tkp9/", {
    method: "POST",
    body: JSON.stringify({
      user: {
        email: userData.email,
        name: userData.name,
        onboarding: {
          completed: true,
          date: timeProvider.getDateTime().format("YYYY-MM-DD"),
        },
      },
    }),
  });
};
